import Handler from "../Handler";
class PauseFinalTableHandler extends Handler {
    // TPauseFinalTable#{tourneyId : weubv}
    execute(message) {
        console.log("PauseFinalTableHandler Handled", message);
        let receivedData = JSON.parse(message);
        this.service.processPauseFinalTable(receivedData);
    }
}
export default PauseFinalTableHandler;
